import { render } from "./Populate.vue?vue&type=template&id=00adeec0&scoped=true&ts=true"
import script from "./Populate.vue?vue&type=script&lang=ts"
export * from "./Populate.vue?vue&type=script&lang=ts"

import "./Populate.vue?vue&type=style&index=0&id=00adeec0&lang=scss&scoped=true"

import exportComponent from "/builds/arkindex/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00adeec0"]])

export default __exports__